import { connect } from "scrivito"
import { InstallationReferenceObj } from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"

import { InstallationReferenceTabContentView } from "./InstallationReferenceTabContentView"
import { useInstallationReferenceTabContentViewModel } from "./hooks/useInstallationReferenceTabContentViewModel"

export interface InstallationReferenceTabContentProps {
  installationReferenceObj: InstallationReferenceObj
}

export const InstallationReferenceTabContent = connect(
  (props: InstallationReferenceTabContentProps) => (
    <InstallationReferenceTabContentView
      {...useInstallationReferenceTabContentViewModel(props)}
    />
  )
)
